<template>
  <div
    class="matrix-grid-input"
    :class="{ answered }"
  >
    <input
      :id="`${inputId}-input-${answer.id}-${selectionIndex}`"
      class="answer-input"
      :type="inputType"
      :name="answer.id"
      :checked="selected"
      :disabled="answered"
      @change="handleAnswer($event, answer.id, selectionIndex)"
    />
    <label
      :for="`${inputId}-input-${answer.id}-${selectionIndex}`"
      class="answer-label"
      :class="{ correct, incorrect, selected }"
    >
      <div class="ring">
        <div class="fill">
          <icon
            v-if="answerIcon"
            :name="answerIcon"
            variant="white"
            class="answer-icon"
          />
        </div>
      </div>
      <slot />
    </label>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  name: 'MatrixGridInput',
  components: { Icon },
  props: {
    answer: {
      type: Object,
    },
    answered: {
      type: Boolean,
    },
    correct: {
      type: Boolean,
    },
    incorrect: {
      type: Boolean,
    },
    inputId: {
      type: String,
    },
    inputType: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
    selectionIndex: {
      type: Number,
    },
  },
  computed: {
    answerIcon() {
      if (this.answered) {
        if (this.correct) {
          return 'check';
        } else if (this.incorrect) {
          return 'cross-thin';
        }
      }
    },
  },
  methods: {
    handleAnswer(event, answerId, selectionIndex) {
      const params = {
        value: event.target.checked,
        answerId,
        selectionIndex,
      };
      this.$emit('handle-answer', params);
    },
  },
};
</script>

<style lang="scss">
.matrix-grid-input {
  .answer-input  {
    display: none;
  }

  .answer-input[type='radio'] ~ .answer-label {
    .ring {
      border-radius: 50%;

      .fill {
        border-radius: 50%;
      }
    }
  }

  .answer-input[type="checkbox"] ~ .answer-label {
    .ring {
      border-radius: 4px;

      .fill {
        border-radius: 2px;
      }
    }
  }

  .answer-label {
    align-items: center;


    .ring {
      align-items: center;
      border: 1px solid #00d8f8;
      display: flex;
      height: 20px;
      justify-content: center;
      width: 20px;

      .fill {
        height: 16px;
        width: 16px;
      }
    }

    &.selected {
      .ring {
        .fill {
          background-color: #00d8f8;
        }
      }
    }
  }

  &.answered {
    .answer-label {
      &.correct {
        .ring {
          border-color: #00b866;
          background-color: #00b866;
        }

        .fill {
          align-items: center;
          background-color: #00b866 !important;
          display: flex;
          height: 20px;
          justify-content: center;
          width: 20px;

          .answer-icon {
            height: 12px;
            width: 12px;
          }
        }
      }

      &.incorrect {
        .ring {
          border-color: #ee1300;
          background-color: #ee1300;
        }

        .fill {
          align-items: center;
          background-color: #ee1300 !important;
          display: flex;
          height: 20px;
          justify-content: center;
          width: 20px;

          .answer-icon {
            height: 8px;
            width: 8px;
          }
        }
      }

      &.selected {
        background-color: #e5fbfe;
      }
    }
  }
}
</style>
